module.exports = __webpack_public_path__ + "img/default.85464f48.png";